import React, { createContext, ReactNode, useContext, useState } from 'react'

interface Marker {
  id: string
  position: google.maps.LatLngLiteral
  price: number
}

interface MarkersContextProps {
  markers: Marker[]
  addMarker: (marker: Marker) => void
  removeMarker: (id: string) => void
  activeMarker: string | null
  setActiveMarker: (id: string | null) => void
  handleActiveMarker: (id: string | null) => void
  handleClosePanel: () => void
}

const MarkersContext = createContext<MarkersContextProps | undefined>(undefined)

export const MarkersProvider = ({ children }: { children: ReactNode }) => {
  const [markers, setMarkers] = useState<Marker[]>([])
  const [activeMarker, setActiveMarker] = useState<string | null>(null)

  const addMarker = (marker: Marker) => {
    setMarkers((prevMarkers) => [...prevMarkers, marker])
  }

  const removeMarker = (id: string) => {
    setMarkers((prevMarkers) =>
      prevMarkers.filter((marker) => marker.id !== id),
    )
  }

  const handleActiveMarker = (markerId: string | null) => {
    setActiveMarker(markerId)
  }

  const handleClosePanel = () => {
    setActiveMarker(null)
  }

  return (
    <MarkersContext.Provider
      value={{
        markers,
        addMarker,
        removeMarker,
        activeMarker,
        setActiveMarker,
        handleActiveMarker,
        handleClosePanel,
      }}
    >
      {children}
    </MarkersContext.Provider>
  )
}

export const useMarkersContext = (): MarkersContextProps => {
  const context = useContext(MarkersContext)
  if (!context) {
    throw new Error('useMarkersContext must be used within a MarkersProvider')
  }
  return context
}
